
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { User } from './user';
import { UserService } from './user.service';
import { NotifierService } from '../ui';
import { DialogService } from '../ui';

@Component({
  templateUrl: './user-list.component.html',
})
export class UserListComponent implements OnInit {

  perPage = 10
  usersCount: number = 0
  users: User[]

  constructor(
    private userService: UserService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.users.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.userService
      .users(offset, limit).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.users = result.users;
        }
        // Append
        else {
          this.users = [...this.users || [], ...result.users];
        }

        this.usersCount = result.usersCount;
      });
  }

  edit(user: User, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['settings/users', user.id]);
    }
  }

  delete(user: User) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cet utilisateur?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.userService
          .delete(user.id)
          .subscribe((id) => {
            this.notifier.success('Utilisateur supprimé avec succès');

            this.fetch(0, this.users.length, true);

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }
}
